import script from "./orderList.vue?vue&type=script&lang=ts&setup=true"
export * from "./orderList.vue?vue&type=script&lang=ts&setup=true"

import "./orderList.vue?vue&type=style&index=0&id=5ed476a9&lang=less&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-5ed476a9"]])

export default __exports__